/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProceedingParticipantSearchResult } from './ProceedingParticipantSearchResult';
import {
    ProceedingParticipantSearchResultFromJSON,
    ProceedingParticipantSearchResultFromJSONTyped,
    ProceedingParticipantSearchResultToJSON,
    ProceedingParticipantSearchResultToJSONTyped,
} from './ProceedingParticipantSearchResult';

/**
 * 
 * @export
 * @interface SearchResultsOfProceedingParticipantSearchResult
 */
export interface SearchResultsOfProceedingParticipantSearchResult {
    /**
     * 
     * @type {Array<ProceedingParticipantSearchResult>}
     * @memberof SearchResultsOfProceedingParticipantSearchResult
     */
    data: Array<ProceedingParticipantSearchResult>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultsOfProceedingParticipantSearchResult
     */
    hasMoreItems: boolean;
}

/**
 * Check if a given object implements the SearchResultsOfProceedingParticipantSearchResult interface.
 */
export function instanceOfSearchResultsOfProceedingParticipantSearchResult(value: object): value is SearchResultsOfProceedingParticipantSearchResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('hasMoreItems' in value) || value['hasMoreItems'] === undefined) return false;
    return true;
}

export function SearchResultsOfProceedingParticipantSearchResultFromJSON(json: any): SearchResultsOfProceedingParticipantSearchResult {
    return SearchResultsOfProceedingParticipantSearchResultFromJSONTyped(json, false);
}

export function SearchResultsOfProceedingParticipantSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultsOfProceedingParticipantSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ProceedingParticipantSearchResultFromJSON)),
        'hasMoreItems': json['hasMoreItems'],
    };
}

export function SearchResultsOfProceedingParticipantSearchResultToJSON(json: any): SearchResultsOfProceedingParticipantSearchResult {
    return SearchResultsOfProceedingParticipantSearchResultToJSONTyped(json, false);
}

export function SearchResultsOfProceedingParticipantSearchResultToJSONTyped(value?: SearchResultsOfProceedingParticipantSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ProceedingParticipantSearchResultToJSON)),
        'hasMoreItems': value['hasMoreItems'],
    };
}

